<div class="relative min-h-[600px]">
  <!-- Close Button (top-right) -->
  <div class="relative">
    <span
      mat-dialog-title
      class="block w-fit max-w-[calc(100%-48px)] text-3xl font-bold"
    >
      Jármű módosítása
    </span>
    <button
      mat-icon-button
      mat-dialog-close
      color="primary"
      class="absolute top-0 right-0 scale-125"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Loading spinner -->
  <div
    *ngIf="loading"
    class="absolute -inset-10 z-10 flex items-center justify-center bg-white"
  >
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <!-- Scrollable Content Container -->
  <div class="dialog-content" *ngIf="!loading">
    <form [formGroup]="editForm!" class="md:px-4">
      <!-- Two Column Layout: Left = Car Details, Right = Services -->
      <div class="flex flex-col flex-wrap gap-6 md:flex-row">
        <!-- LEFT COLUMN: Car Details -->
        <div class="w-full lg:w-[calc(50%-12px)]">
          <!-- Car Name -->
          <mat-form-field appearance="standard" class="w-full">
            <mat-label>Jármű neve</mat-label>
            <input matInput formControlName="name" />
            <mat-error *ngIf="editForm!.get('name')?.hasError('required')">
              Kötelező mező
            </mat-error>
          </mat-form-field>

          <!-- Make + Model (Row) -->
          <div class="flex gap-4">
            <mat-form-field appearance="standard" class="w-[calc(50%-8px)]">
              <mat-label>Jármű márkája</mat-label>
              <input matInput formControlName="make" />
              <mat-error *ngIf="editForm!.get('make')?.hasError('required')">
                Kötelező mező
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="standard" class="w-[calc(50%-8px)]">
              <mat-label>Jármű típusa</mat-label>
              <input matInput formControlName="model" />
              <mat-error *ngIf="editForm!.get('model')?.hasError('required')">
                Kötelező mező
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Category + Model ID (Row) -->
          <div class="flex gap-4">
            <mat-form-field appearance="standard" class="w-[calc(50%-8px)]">
              <mat-label>Jármű kategóriája</mat-label>
              <input matInput formControlName="category" />
              <mat-error
                *ngIf="editForm!.get('category')?.hasError('required')"
              >
                Kötelező mező
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="standard" class="w-[calc(50%-8px)]">
              <mat-label>Model ID</mat-label>
              <input matInput formControlName="modelId" />
              <mat-error *ngIf="editForm!.get('modelId')?.hasError('required')">
                Kötelező mező
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Seats + Luggage (Row with Dropdowns) -->
          <div class="flex justify-between gap-4">
            <mat-form-field appearance="standard" class="w-[30%]">
              <mat-label>Férőhely száma</mat-label>
              <mat-select formControlName="numberOfSeats">
                <mat-option *ngFor="let option of seatOptions" [value]="option">
                  {{ option }} db
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="editForm!.get('numberOfSeats')?.hasError('required')"
              >
                Kötelező mező
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="standard" class="w-[30%]">
              <mat-label>Nagy bőrönd</mat-label>
              <mat-select formControlName="largeLuggageCapacity">
                <mat-option
                  *ngFor="let option of luggageOptions"
                  [value]="option"
                >
                  {{ option }} db
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  editForm!.get('largeLuggageCapacity')?.hasError('required')
                "
              >
                Kötelező mező
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="standard" class="w-[30%]">
              <mat-label>Kis táska</mat-label>
              <mat-select formControlName="smallLuggageCapacity">
                <mat-option
                  *ngFor="let option of luggageOptions"
                  [value]="option"
                >
                  {{ option }} db
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  editForm!.get('smallLuggageCapacity')?.hasError('required')
                "
              >
                Kötelező mező
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Transmission (Radio buttons) -->
          <div class="mb-4">
            <p class="mb-2 text-sm font-medium">Váltó típusa</p>
            <mat-radio-group formControlName="transmission" class="flex gap-6">
              <mat-radio-button value="AUTOMATIC" color="primary"
                >Automata</mat-radio-button
              >
              <mat-radio-button value="MANUAL" color="primary"
                >Manuális</mat-radio-button
              >
            </mat-radio-group>
          </div>

          <!-- Image Upload -->
          <div class="mb-4">
            <label class="mb-2 block text-sm font-medium">Kép</label>

            <!-- Upload Zone (no image) -->
            <div
              *ngIf="!displayImageIndicator"
              (click)="openImageUploadDialog()"
              class="hover:bg-gray-50 flex h-12 cursor-pointer items-center rounded-lg border-2 border-dashed border-light-gray px-3 transition-colors"
            >
              <div class="flex items-center gap-2 text-dark-gray">
                <mat-icon class="text-turquoise">image</mat-icon>
                <span class="text-sm">Kép hozzáadása</span>
              </div>
            </div>

            <!-- Image Indicator (has image or pending upload) -->
            <div
              *ngIf="displayImageIndicator"
              class="flex items-center justify-between rounded-lg border border-customGreen-400 bg-customGreen-100 px-3 py-1"
            >
              <div
                (click)="openImageUploadDialog()"
                class="flex flex-1 cursor-pointer items-center gap-2"
              >
                <mat-icon class="text-turquoise">image</mat-icon>
                <span class="text-sm font-medium">
                  {{ pendingImageFile?.name }}
                </span>
              </div>
              <button
                type="button"
                mat-icon-button
                (click)="softDeleteImage(); $event.stopPropagation()"
                class="text-customRed-300"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- RIGHT COLUMN: Services -->
        <div class="w-full lg:w-[calc(50%-12px)]">
          <div
            class="mb-2 flex w-full flex-col gap-3 overflow-hidden rounded-lg bg-light-cyan p-3"
          >
            <!-- Default Services (Always present, checkbox to enable/disable) -->
            <p
              *ngFor="let service of defaultServices; let i = index"
              class="w-full"
            >
              <mat-checkbox
                [checked]="service.enabled"
                (change)="toggleDefaultService(i)"
                class="flex w-full items-start"
              >
                <span class="!inline-block whitespace-pre-line">
                  {{ service.nameHu }}
                </span>
              </mat-checkbox>
            </p>

            <!-- Custom Services (Can be deleted) -->
            <div
              *ngFor="let service of customServices; let i = index"
              class="flex w-full items-center gap-2"
            >
              <mat-checkbox
                [checked]="service.enabled"
                (change)="toggleCustomService(i)"
                class="w-full max-w-[calc(100%-40px)]"
              >
                <div>
                  <span class="block truncate whitespace-pre-line">{{ service.nameHu }}</span>
                  <span class="-mt-1 block truncate whitespace-pre-line text-sm text-dark-gray">{{
                    service.nameEn
                  }}</span>
                </div>
              </mat-checkbox>
              <button
                type="button"
                mat-icon-button
                (click)="removeCustomService(i)"
                class="text-customRed-300"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <!-- Add New Service Form (Shown when adding) -->
          <div
            *ngIf="isAddingNewService"
            class="mb-4 rounded-lg border-2 border-customGreen-400 p-4"
          >
            <h3 class="mb-4 text-lg font-bold text-dark-green">
              Új hozzáadása
            </h3>

            <form [formGroup]="newServiceForm">
              <mat-form-field appearance="standard" class="w-full">
                <mat-label>Extra szolgáltatás neve magyarul</mat-label>
                <input matInput formControlName="nameHu" />
                <mat-error
                  *ngIf="newServiceForm.get('nameHu')?.hasError('required')"
                >
                  Kötelező mező
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="standard" class="w-full">
                <mat-label>Extra szolgáltatás neve angolul</mat-label>
                <input matInput formControlName="nameEn" />
                <mat-error
                  *ngIf="newServiceForm.get('nameEn')?.hasError('required')"
                >
                  Kötelező mező
                </mat-error>
              </mat-form-field>

              <!-- Action Buttons for New Service -->
              <div class="mt-2 flex gap-3">
                <button
                  type="button"
                  mat-stroked-button
                  color="primary"
                  (click)="cancelAddService()"
                  class="flex-1 rounded-xl"
                >
                  Mégsem
                </button>
                <button
                  type="button"
                  mat-flat-button
                  color="primary"
                  (click)="addNewService()"
                  [disabled]="!newServiceForm.valid"
                  class="flex-1 rounded-xl"
                >
                  Hozzáad
                </button>
              </div>
            </form>
          </div>

          <!-- Add New Service Button (Hidden when form is shown) -->
          <div class="flex justify-end">
            <button
              *ngIf="!isAddingNewService"
              type="button"
              mat-button
              color="primary"
              (click)="showAddServiceForm()"
              class="justify-start text-sm font-bold text-dark-green"
            >
              Új hozzáadása
              <mat-icon class="ml-1 h-5 w-5 text-[20px]">add_circle</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Action Buttons -->
  <div
    mat-dialog-actions
    class="mb-0 mt-8 flex flex-col justify-end gap-4 border-t border-light-gray pt-6 md:flex-row md:border-none md:pt-0"
  >
    <button
      mat-stroked-button
      color="primary"
      (click)="onCancel()"
      [disabled]="loading"
      class="mol-btn-stroked-primary lg:mol-btn-lg h-12 w-full rounded-2xl text-base font-bold md:h-16 lg:max-w-[380px]"
    >
      Mégse
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="onSave()"
      [disabled]="loading || !editForm?.valid"
      class="lg:mol-btn-lg ml-0 h-12 w-full rounded-2xl text-base font-bold md:h-16 lg:max-w-[380px]"
    >
      Módosítás
    </button>
  </div>
</div>
